import r from "../managers/braze-instance.js";
import nr from "./feature-flags-provider-factory.js";
export function getAllFeatureFlags() {
  if (!r.rr()) return;
  var t = [],
    e = r.l();
  if (e && !e.Re()) return t;
  var n = nr.o().De();
  for (var _r in n) t.push(n[_r]);
  return t;
}